import React from 'react';
import { UserTier, TIER_CONFIG, TIER_THRESHOLDS } from 'types/interfaces/leaderboard';
import './RankTierBadge.css';

interface RankTierBadgeProps {
  tier: UserTier;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

const RankTierBadge: React.FC<RankTierBadgeProps> = ({
  tier,
  size = 'medium',
  showTooltip = true,
}) => {
  const config = TIER_CONFIG[tier];
  const thresholds = TIER_THRESHOLDS[tier];

  const getTooltipText = () => {
    if (thresholds.max === null) {
      return `${config.label} Tier: ${thresholds.min}+ completed trades`;
    }
    return `${config.label} Tier: ${thresholds.min}-${thresholds.max} completed trades`;
  };

  if (tier === 'seedling') {
    return (
      <div
        className={`rank-tier-badge rank-tier-badge--${size} rank-tier-badge--seedling-emoji`}
        title={showTooltip ? getTooltipText() : undefined}
      >
        🌱
      </div>
    );
  }

  return (
    <span
      className={`rank-tier-badge rank-tier-badge--${size} rank-tier-badge--${tier}`}
      style={{ backgroundColor: config.color }}
      title={showTooltip ? getTooltipText() : undefined}
    >
      {config.label}
    </span>
  );
};

export default RankTierBadge;
